<template>
  <Modal
    ref="modal"
    v-bind="[$attrs, $listeners]"
    :loading="loading"
    :loading-text="loadingText"
    :title="title"
    :summary="tab == 'details' && item && Object.keys(item).length ? item.title[locale] : null"
    :close-on-bg-click="(false)"
    @open="onOpen"
    @close="onClose"
    :back-button="(prevTab && prevTab.length) ? true : false"
    @back="gotoPrevTab"
    :size="size"
    class="candidateDetails"
  >
    <template v-if="item && Object.keys(item).length">
      <!-- Candidate details -->
      <template v-if="tab == 'details'">
        <div class="candidateDetails__details">
          <div class="candidateDetails__col candidateDetails__col--left p-double">
            <dl class="detailList">
              <!-- <div
                v-if="item.title"
                class="detailList__item"
              >
                <dt class="detailList__title">
                  {{ $t('candidate.title') }}
                </dt>
                <dd class="detailList__value">
                  {{ item.title[locale] }}
                </dd>
              </div> -->
              <div
                v-if="item.age_is_hidden != 1 && item.age"
                class="detailList__item"
              >
                <dt class="detailList__title">
                  {{ $t('candidate.age') }}
                </dt>
                <dd class="detailList__value">
                  {{ item.age }}
                  <span aria-hidden="true">{{ $t('candidate.yearsAbbreviation') }}</span>
                  <span class="sr-only">{{ $t('candidate.years') }}</span>
                </dd>
              </div>
              <div
                v-if="item.commune && item.commune.title"
                class="detailList__item"
              >
                <dt class="detailList__title">
                  {{ $t('candidate.commune') }}
                </dt>
                <dd class="detailList__value">
                  {{ [
                    item.location || undefined,
                    item.commune.title || undefined,
                  ].filter(item => !!item).join(', ') }}
                </dd>
              </div>
            </dl>
            <IconNav
              v-if="
                item.website ||
                  item.facebook ||
                  item.twitter ||
                  item.bluesky ||
                  item.instagram ||
                  item.tiktok ||
                  item.linkedin ||
                  item.youtube
              "
            >
              <h2 class="sr-only">
                {{ $t('titles.candidateInSocialMedia') }}
              </h2>
              <IconNavItem
                v-if="item.website"
                icon="home"
                :href="item.website"
                :label="$t('candidate.website')"
                target="_blank"
              />
              <IconNavItem
                v-if="item.facebook"
                :icon="['fab', 'facebook-square']"
                :href="item.facebook"
                label="Facebook"
                target="_blank"
              />
              <IconNavItem
                v-if="item.twitter"
                :icon="['fab', 'x-twitter']"
                :href="item.twitter"
                label="X"
                target="_blank"
              />
              <IconNavItem
                v-if="item.bluesky"
                :icon="['fab', 'bluesky']"
                :href="item.bluesky"
                label="Bluesky Social"
                target="_blank"
              />
              <IconNavItem
                v-if="item.instagram"
                :icon="['fab', 'instagram']"
                :href="item.instagram"
                label="Instagram"
                target="_blank"
              />
              <IconNavItem
                v-if="item.tiktok"
                :icon="['fab', 'tiktok']"
                :href="item.tiktok"
                label="Tiktok"
                target="_blank"
              />
              <IconNavItem
                v-if="item.linkedin"
                :icon="['fab', 'linkedin']"
                :href="item.linkedin"
                label="LinkedIn"
                target="_blank"
              />
              <IconNavItem
                v-if="item.youtube"
                :icon="['fab', 'youtube']"
                :href="item.youtube"
                label="YouTube"
                target="_blank"
              />
            </IconNav>
            <div
              v-if="item.description[locale]"
              :class="{ 'is-collapsed': isCollapsed }"
            >
              <p>{{ item.description[locale] }}</p>
              <button
                type="button"
                class="button button--text"
                v-if="canCollapse"
                @click="(hasCollapsed = !hasCollapsed)"
              >
                <span v-if="hasCollapsed">{{ $t('buttons.showMore.label') }}</span>
                <span v-else>{{ $t('buttons.showLess.label') }}</span>
              </button>
            </div>
          </div>
          <div
            v-if="imgUrl"
            class="candidateDetails__col candidateDetails__col--right"
          >
            <div class="candidateDetails__imgWrap">
              <img
                class="candidateDetails__image"
                :src="imgUrl"
                alt=""
                width="350"
                height="420"
              >
              <div
                v-if="item.number"
                class="candidateDetails__badgeWrap p-single"
              >
                <Badge
                  :label="$t('candidate.number')"
                  :text="item.number"
                />
              </div>
            </div>
          </div>
        </div>

        <InputfieldButtonSet slot="footer">
          <InputfieldButton
            v-if="enableDonation && item.bank && !item.removed"
            id="cancel"
            :text="$t('buttons.donate.label')"
            icon="heart"
            @click="tab = 'donate'"
          />
        </InputfieldButtonSet>
        <InputfieldButtonSet slot="footer-right">
          <InputfieldButton
            v-if="shareUrl && Object.keys(shareUrl).length"
            id="cancel"
            :text="$t('buttons.share.label')"
            icon="share"
            @click="tab = 'share'"
          />
        </InputfieldButtonSet>
      </template>

      <!-- Donation form -->
      <template v-if="tab == 'donate' && enableDonation && item.bank && !item.removed">
        <div class="p-double">
          <InputfieldForm>
            <InputfieldButton
              v-if="devMode"
              id="dummyData"
              text="Täytä lomake testidatalla"
              :disabled="loadingDonation"
              :loading="loadingDonation"
              @click="fillFormDummyData"
            />

            <InputfieldFieldset
              :label="$t('titles.donationSum')"
            >
              <InputfieldAutoComplete
                v-model="donationFormData.sum"
                :label="$t('fields.sum.label')"
                id="sum"
                :items="[
                  ...donationSums,
                  {
                    id: 'custom',
                    title: $t('fields.sumCustom.label'),
                  },
                ]"
                :value="20"
                :notes="$t('fields.sum.notes')"
                :required="(true)"
                :searchable="(false)"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
              />
              <InputfieldText
                v-show="donationFormData.sum && donationFormData.sum.id == 'custom'"
                v-model="donationFormData.sumCustom"
                :label="$t('fields.sumCustom.label')"
                :notes="$t('fields.sumCustom.notes')"
                id="sumCustom"
                type="number"
                :required="(true)"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
                ref="sumCustom"
              />
            </InputfieldFieldset>

            <InputfieldFieldset
              :label="$t('titles.companyDetails')"
            >
              <InputfieldCheckbox
                v-model="donationFormData.behalf"
                id="behalf"
                :label="$t('fields.behalfCompany.label')"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
              />
              <template v-if="donationFormData.behalf">
                <InputfieldText
                  v-model="donationFormData.organization"
                  :label="$t('fields.organizationName.label')"
                  id="organization"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                  :required="(true)"
                />
                <InputfieldText
                  v-model="donationFormData.business_id"
                  :label="$t('fields.vatId.label')"
                  id="business_id"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                  :required="(true)"
                />
                <InputfieldAutoComplete
                  v-model="donationFormData.organization_type"
                  :label="$t('fields.organizationType.label')"
                  id="organization_type"
                  :items="organizationTypes"
                  :required="(true)"
                  :searchable="(false)"
                  :multilang="true"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                />
                <InputfieldText
                  v-model="donationFormData.organization_postal"
                  :label="$t('fields.postal.label')"
                  id="organization_postal"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                  :required="(true)"
                />
                <InputfieldAutoComplete
                  v-model="donationFormData.organization_commune"
                  :label="$t('fields.commune.label')"
                  id="organization_commune"
                  :items="communes"
                  :required="(true)"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                />
                <InputfieldText
                  v-model="donationFormData.organization_email"
                  :label="$t('fields.email.label')"
                  id="organization_email"
                  type="email"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                  :required="(true)"
                />
              </template>
            </InputfieldFieldset>

            <InputfieldFieldset
              :label="$t('titles.donorDetails')"
            >
              <InputfieldText
                v-model="donationFormData.firstname"
                :label="$t('fields.firstName.label')"
                id="firstname"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
                :required="(true)"
              />
              <InputfieldText
                v-model="donationFormData.lastname"
                :label="$t('fields.lastName.label')"
                id="lastname"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
                :required="(true)"
              />
              <InputfieldCheckbox
                v-model="donationFormData.donation_abroad"
                id="donation_abroad"
                :label="$t('fields.donationAbroad.label')"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
              />
              <template v-if="donationFormData.donation_abroad">
                <InputfieldAutoComplete
                  v-model="donationFormData.country"
                  :label="$t('fields.country.label')"
                  id="country"
                  :items="countries"
                  :required="(true)"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                />
              </template>
              <template v-else>
                <InputfieldText
                  v-model="donationFormData.postal"
                  :label="$t('fields.postal.label')"
                  id="postal"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                  :required="(true)"
                />
                <InputfieldAutoComplete
                  v-model="donationFormData.commune"
                  :label="$t('fields.locality.label')"
                  id="commune"
                  :items="communes"
                  :required="(true)"
                  :disabled="loadingDonation"
                  :errors="donationFormErrors"
                />
              </template>
              <InputfieldText
                v-model="donationFormData.email"
                :label="$t('fields.email.label')"
                id="email"
                type="email"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
                :required="(true)"
              />
              <InputfieldTextarea
                v-model="donationFormData.message"
                :label="$t('fields.message.label')"
                id="message"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
              />
              <InputfieldCheckbox
                v-model="donationFormData.contact"
                id="donor_contact"
                :label="$t('fields.donorContact.label')"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
              >
                <template slot="notes">
                  {{ $t('fields.donorContact.notes') }}:
                  <a
                    href="https://www.kd.fi/tietosuojaseloste/"
                    target="_blank"
                  >
                    https://www.kd.fi/tietosuojaseloste/
                  </a>
                </template>
              </InputfieldCheckbox>
              <InputfieldCheckbox
                v-model="donationFormData.public"
                id="donor_public"
                :label="$t('fields.donorPublic.label')"
                :notes="$t('fields.donorPublic.notes')"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
              />
              <InputfieldCheckbox
                id="terms_accepted"
                v-model="donationFormData.terms_accepted"
                :label="$t('fields.donorTermsAccepted.label')"
                :required="true"
                :disabled="loadingDonation"
                :errors="donationFormErrors"
              >
                <template slot="notes">
                  <a
                    href="https://www.kd.fi/tietosuojaseloste/"
                    target="_blank"
                  >
                    https://www.kd.fi/tietosuojaseloste/
                  </a>
                </template>
              </InputfieldCheckbox>
              <InputfieldButton
                v-if="!sveaPaymentFormData || !Object.keys(sveaPaymentFormData).length"
                id="donate"
                :text="$t('buttons.proceedToPayment.label')"
                :notes="$t('buttons.proceedToPayment.notes')"
                :disabled="loadingDonation"
                :loading="loadingDonation"
                :errors="(donationFormErrors && Object.keys(donationFormErrors).length ? {donate: ['Lomakkeella on virheitä. Tarkista kentät ja yritä uudelleen.']} : {})"
                @click="donate"
              >
                <template slot="notes">
                  {{ $t('buttons.proceedToPayment.notes') }}:
                  <a
                    href="https://www.kd.fi/rahankerayslupa"
                    target="_blank"
                  >
                    https://www.kd.fi/rahankerayslupa
                  </a>
                </template>
              </InputfieldButton>
            </InputfieldFieldset>
          </InputfieldForm>
          <form
            ref="sveaPaymentForm"
            class="sveaPaymentForm"
            method="post"
            :action="sveaPaymentFormUrl"
            :style="{
              display: devMode ? 'block' : 'none',
            }"
          >
            <template v-if="sveaPaymentFormData && Object.keys(sveaPaymentFormData).length">
              <div
                :class="{
                  'sveaPaymentForm__fields': true,
                  'sveaPaymentForm__fields--hidden': devMode === false,
                }"
              >
                <input
                  v-for="(value, name, index) in sveaPaymentFormData"
                  :key="index"
                  :name="name"
                  :value="value"
                >
              </div>
              <InputfieldButton
                type="submit"
                :text="$t('buttons.proceedToPaymentService.label')"
              >
                <template slot="notes">
                  {{ $t('buttons.proceedToPaymentService.notes') }}
                </template>
              </InputfieldButton>
            </template>
          </form>
        </div>
      </template>

      <!-- Thank you for your donation -->
      <div
        v-if="tab == 'thanks'"
        class="p-double"
      >
        <Notify
          icon="heart"
          :title="$t('titles.thanksForYourDonation')"
          :text="item.candidate_message[locale]"
        >
          <InputfieldButton
            text="OK"
            @click="reset"
          />
        </Notify>
      </div>

      <!-- Donation was canceled -->
      <div
        v-if="tab == 'donationCanceled'"
        class="p-double"
      >
        <Notify
          type="neutral"
          icon="times"
          title="Lahjoitus keskeytettiin"
          text="Tiliäsi ei veloitettu."
        >
          <InputfieldButton
            text="OK"
            @click="gotoPrevTab"
          />
        </Notify>
      </div>

      <!-- Payment check has failed -->
      <div
        v-if="tab == 'paymentCheckFailed'"
        class="p-double"
      >
        <Notify
          type="error"
          icon="times"
          :title="$t('infoTexts.paymentCheckFailed')"
        >
          <InputfieldButton
            :text="$t('buttons.tryAgain.label')"
            @click="checkPayment"
          />
        </Notify>
      </div>

      <!-- Share to social media -->
      <div
        v-if="tab == 'share'"
        class="p-double"
      >
        <ul
          v-if="shareUrl && Object.keys(shareUrl).length"
          class="sharingButtons"
        >
          <li
            class="sharingButtons__item"
            v-if="enableDonation && item.bank && !item.removed"
          >
            <a
              @click="copyLink(true)"
              class="sharingButtons__link p-single"
              target="_blank"
            >
              <font-awesome-icon
                class="sharingButtons__icon"
                :icon="['fas', 'euro-sign']"
              />
              <span class="sharingButtons__text">
                {{ $t('buttons.copyLink.donation.label') }}
              </span>
            </a>
          </li>
          <li class="sharingButtons__item">
            <a
              @click="copyLink()"
              class="sharingButtons__link p-single"
              target="_blank"
            >
              <font-awesome-icon
                class="sharingButtons__icon"
                :icon="['fas', 'id-card-clip']"
              />
              <span class="sharingButtons__text">
                {{ $t('buttons.copyLink.card.label') }}
              </span>
            </a>
          </li>
          <li
            v-if="shareUrl.facebook"
            class="sharingButtons__item"
          >
            <a
              :href="shareUrl.facebook"
              class="sharingButtons__link p-single"
              target="_blank"
            >
              <font-awesome-icon
                class="sharingButtons__icon"
                :icon="['fab', 'facebook-square']"
              />
              <span class="sharingButtons__text">
                {{ $t('buttons.shareInFacebook.label') }}
              </span>
            </a>
          </li>
          <li
            v-if="shareUrl.twitter"
            class="sharingButtons__item"
          >
            <a
              :href="shareUrl.twitter"
              class="sharingButtons__link p-single"
              target="_blank"
            >
              <font-awesome-icon
                class="sharingButtons__icon"
                :icon="['fab', 'x-twitter']"
              />
              <span class="sharingButtons__text">
                {{ $t('buttons.shareInTwitter.label') }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </template>
  </Modal>
</template>

<script>

export default {
  name: 'CandidateDetails',
  data: () => ({
    devMode: process.env.NODE_ENV === 'development',
    tab: null,
    loading: false,
    loadingText: null,
    loadingDonation: false,
    enableDonation: true,
    donationFormErrors: {},
    donationFormData: {},
    sveaPaymentFormUrl: process.env.VUE_APP_SVEAPAYMENT_URL,
    sveaPaymentFormData: {},
    sveaPaymentReturnData: {},
    donationSums: [
      {
        id: 10,
        title: '10,00 €',
      },
      {
        id: 15,
        title: '15,00 €',
      },
      {
        id: 20,
        title: '20,00 €',
      },
      {
        id: 25,
        title: '25,00 €',
      },
      {
        id: 50,
        title: '50,00 €',
      },
      {
        id: 75,
        title: '75,00 €',
      },
      {
        id: 100,
        title: '100,00 €',
      },
      {
        id: 200,
        title: '200,00 €',
      },
      {
        id: 500,
        title: '500,00 €',
      },
    ],
    hasCollapsed: true,
    collapsedThreshold: 280,
  }),
  props: {
    item: {
      type: Object,
      required: false,
      default () {
        return {}
      },
    },
    communes: {
      type: Array,
      required: false,
      default () {
        return []
      },
    },
    organizationTypes: {
      type: Array,
      required: false,
      default () {
        return []
      },
    },
    countries: {
      type: Array,
      required: false,
      default () {
        return []
      },
    },
    locale: {
      type: String,
      required: false,
      default () {
        return []
      },
    },
    preSelectedTab: {
      type: String,
      required: false,
      default () {
        return null
      },
    },
    size: {
      type: String,
      required: false,
      default () {
        return null
      },
    },
  },
  computed: {
    isCollapsed () {
      if (this.$route.path.includes('/ehdokas/')) return false

      return (this.hasCollapsed && (this.item.description[this.locale].length > this.collapsedThreshold))
    },

    canCollapse () {
      if (this.$route.path.includes('/ehdokas/')) return false

      return (this.item.description[this.locale].length > this.collapsedThreshold)
    },

    title () {
      if (!this.item || !Object.keys(this.item).length) return ''

      return [
        this.item.firstname,
        this.item.lastname,
        this.item.nonpartisan == 1 ? '(' + this.$t('candidate.independentAbbreviation') + ')' : null,
      ].join(' ')
    },

    imgUrl () {
      return this.item.profilepic || process.env.VUE_APP_EMBED_URL + 'img/candidate-placeholder.jpg'
    },

    prevTab () {
      if (this.tab == 'donate') return 'details'
      if (this.tab == 'donationCanceled') return 'donate'
      if (this.tab == 'paymentCheckFailed') return 'donate'
      if (this.tab == 'thanks') return 'details'
      if (this.tab == 'share') return 'details'

      return null
    },

    shareUrl () {
      if (!this.item || !Object.keys(this.item).length) return {}

      const queryString = require('query-string')
      const url = encodeURI(process.env.VUE_APP_API_ROOT + 'share/' + this.item.id + '?' + queryString.stringify({
        redirect_to: document.location.href,
      }))

      return {
        facebook: 'https://facebook.com/sharer/sharer.php?' + queryString.stringify({
          u: url,
        }),
        twitter: 'https://twitter.com/intent/tweet/?' + queryString.stringify({
          text: [
            this.item.firstname,
            this.item.lastname,
          ].join(' '),
          url: url,
        }),
      }
    },
  },
  methods: {
    async copyLink (withDonation = false) {
      let link = `https://vaalit.kd.fi/embed/ehdokas/${window.location.search}`
      if (withDonation) {
        link += '&valilehti=donate'
      }
      console.log(link)
      try {
        await navigator.clipboard.writeText(link)
        alert(this.$t('buttons.copyLink.success'))
      } catch (e) {
        alert(`${this.$t('buttons.copyLink.error')} ${link}`)
      }
    },

    onOpen () {
      if (this.preSelectedTab === 'donate') {
        this.tab = this.preSelectedTab
      }
    },

    gotoPrevTab () {
      if (!this.prevTab || !this.prevTab.length) return

      this.tab = this.prevTab
    },

    reset () {
      this.tab = this.preSelectedTab ? this.preSelectedTab : 'details'
      this.loading = false
      this.loadingDonation = false
      this.donationFormErrors = {}
      this.donationFormData = {
        sum: {
          id: 20,
          title: '20,00 €',
        },
      }
      this.sveaPaymentFormData = {}
      this.sveaPaymentReturnData = {}
    },

    clearPaymentURLParams () {
      let params = Object.assign({}, this.$router.currentRoute.query)

      let filteredParams = Object.keys(params).filter(key => {
        if (key.startsWith('pmt_') || key == 'status') return false

        return key
      }).reduce((obj, key) => {
        return {
          ...obj,
          [key]: params[key],
        }
      }, {})

      this.$router.replace({
        query: filteredParams,
      })
    },

    onClose () {
      this.$emit('close')

      setTimeout(() => {
        this.reset()
      }, 200)
    },

    donate () {
      this.donationFormErrors = {}
      this.loadingDonation = true

      // Define base URL without query parameters for return URLs.
      // Svea Payment has limit of 200 characters in return URLs,
      // so we try to keep return URLs as short as possible.
      const baseUrl = document.location.href.split('?')[0]

      // Store query parameters to session storage.
      // When user returns from Svea Payment, we restore query parameters
      // from session storage.
      sessionStorage.setItem('queryParams', JSON.stringify(this.$route.query))

      // Define post data
      const postData = {
        candidate: this.item.id,
        election: this.item.campaign_id,
        donor: {
          firstname: this.donationFormData.firstname,
          lastname: this.donationFormData.lastname,
          donation_abroad: (this.donationFormData.donation_abroad) ? this.donationFormData.donation_abroad : null,
          postal: this.donationFormData.postal,
          commune: (!this.donationFormData.donation_abroad && this.donationFormData.commune) ? this.donationFormData.commune.id : null,
          commune_title: (this.donationFormData.commune) ? this.donationFormData.commune.title : null,
          country: (this.donationFormData.donation_abroad && this.donationFormData.country) ? this.donationFormData.country.id : null,
          email: this.donationFormData.email,
          sum: (this.donationFormData.sum) ? this.donationFormData.sum.id : null,
          sumCustom: this.donationFormData.sumCustom,
          behalf: (this.donationFormData.behalf) ? 1 : null,
          organization: this.donationFormData.organization,
          business_id: this.donationFormData.business_id,
          organization_type: (this.donationFormData.organization_type) ? this.donationFormData.organization_type.id : null,
          organization_commune: (this.donationFormData.organization_commune) ? this.donationFormData.organization_commune.id : null,
          organization_commune_title: (this.donationFormData.organization_commune) ? this.donationFormData.organization_commune.title : null,
          organization_postal: this.donationFormData.organization_postal,
          organization_email: this.donationFormData.organization_email,
          message: this.donationFormData.message,
          contact: (this.donationFormData.contact) ? 1 : 0,
          public: (this.donationFormData.public) ? 1 : 0,
          terms_accepted: (this.donationFormData.terms_accepted) ? 1 : 0,
        },
        pmt_okreturn: baseUrl + '?status=success',
        pmt_errorreturn: baseUrl + '?status=error',
        pmt_cancelreturn: baseUrl + '?status=cancel',
      }

      // Store current donation form data to sessionStorage
      // We will use this to restore form if user decides to cancel payment
      sessionStorage.setItem('donationFormData', JSON.stringify(this.donationFormData))

      // Create new payment
      this.$api({
        method: 'post',
        url: 'createpayment',
        data: postData,
      }).then(res => {
        // Fill Svea Payment form and submit it
        this.sveaPaymentFormData = Object.assign({}, res.data)

        // Post payment form, if we are in production environment
        // In dev mode you need to post it manually
        if (this.devMode === false) {
          // We need to use double nextTick due to the quirks in portal-vue library
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.$refs.sveaPaymentForm.submit()
            })
          })
        }
      }).catch(error => {
        this.loadingDonation = false
        this.donationFormErrors = error.response ? error.response.data : {}
      })
    },

    checkPayment () {
      this.loading = true
      this.loadingText = this.$t('infoTexts.checkingPayment')

      // Get base URL
      const baseUrl = document.location.href.split('?')[0]

      this.$api({
        method: 'post',
        url: 'checkpayment',
        data: {
          ...this.sveaPaymentReturnData,
          candidate: this.item.id,
          election: this.item.campaign_id,
          pmt_okreturn: baseUrl + '?status=success',
          pmt_errorreturn: baseUrl + '?status=error',
          pmt_cancelreturn: baseUrl + '?status=cancel',
        },
      }).then(() => {
        // Everything went smoothly...
        sessionStorage.removeItem('donationFormData')

        this.tab = 'thanks'
      }).catch(error => {
        console.error(error)
        this.tab = 'paymentCheckFailed'
      }).then(() => {
        this.loading = false
      })
    },

    fillFormDummyData () {
      this.donationFormData = Object.assign({}, {
        sum: {
          id: 25,
          title: '25,00 €',
        },
        onbehalf: {},
        behalf: true,
        organization: 'Malliyritys',
        organization_type: {
          id: 1,
          title: {
            fi: 'Yritys',
            sv: 'F\u00f6retag',
            se: 'F\u00f6retag',
            en: 'Company',
          },
        },
        organization_commune: {
          id: 'k086',
          title: 'Hausjärvi',
        },
        organization_postal: '33100',
        business_id: '1234567-8',
        organization_email: 'malli@yritys.fi',
        firstname: 'Jerry',
        lastname: 'Cotton',
        postal: '33100',
        commune: {
          id: 'k103',
          title: 'Humppila',
        },
        email: 'jerry.cotton@gmail.com',
        message: 'Jerry is here',
        contact: true,
        terms_accepted: true,
      })
    },
  },
  watch: {
    tab (val) {
      this.donationFormErrors = {}
      this.$refs.modal.focusOnBox()

      // If current tab is donate
      this.$emit('change-tab', val === 'donate' ? val : null)
    },

    'donationFormData.sum': {
      deep: true,
      handler (after, before) {
        if (!before || !after) return
        if (after.id == before.id || after.id != 'custom') return

        // When user picks custom sum, focus on custom sum field
        if (after.id == 'custom') {
          this.$nextTick(() => {
            this.$nextTick(() => {
              document.getElementById('sumCustom').focus()
            })
          })
        }
      },
    },

    '$route.query': {
      deep: true,
      immediate: true,
      handler () {
        if (!this.item || !Object.keys(this.item).length) return

        // If we got successful payment status set in query string,
        if (this.$router.currentRoute.query && this.$router.currentRoute.query.status) {
          // Get return data
          this.sveaPaymentReturnData = this.$router.currentRoute.query
          this.clearPaymentURLParams()

          switch (this.sveaPaymentReturnData.status) {
            case 'success': {
              this.checkPayment()

              break
            }

            case 'error': {
              console.log('An error occured...')

              break
            }

            case 'cancel': {
              this.tab = 'donationCanceled'

              // Restore payment form state
              if (sessionStorage.getItem('donationFormData')) {
                this.donationFormData = Object.assign({}, JSON.parse(sessionStorage.getItem('donationFormData')))
              }

              break
            }
          }
        }
      },
    },
  },
  mounted () {
    this.reset()
  },
}

</script>

<style lang="scss" scoped>

.is-collapsed {
  > p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;

    @supports (block-overflow: ellipsis) and (max-lines: 3) {
      block-overflow: ellipsis;
      max-lines: 3;
    }
  }
}

.sveaPaymentForm {
  margin-top: 2em;

  &__fields {
    &--hidden {
      height: 0;
      overflow: hidden;
    }
  }
}

</style>
